import React, { Dispatch, RefObject, SetStateAction } from 'react'
import clsx from 'clsx'
import { Box as MenuListBox, Box as PanelBox } from '@node-space/storybook-components/dist/Box'
import { appBannersId } from 'components/app/AppBanners'
import { useSidebarLinks } from 'hooks/sidebar/useSidebarLinks'
import { useComponentHeight } from 'hooks/useComponentHeight'
import SidebarHeader from './Header'
import SideBarLink from './SidebarLink'

interface SidebarProps {
  sidebarOpen: boolean
  setSidebarOpen: Dispatch<SetStateAction<boolean>>
  sidebarRef: RefObject<HTMLDivElement>
}

const SideBar = ({ sidebarOpen, setSidebarOpen, sidebarRef }: SidebarProps) => {
  const bannerSpacing = useComponentHeight(appBannersId)

  const links = useSidebarLinks({ setSidebarOpen })

  return (
    <PanelBox height="full" minHeight="screen" className="lg:w-64">
      <div
        className={clsx(
          'fixed inset-0 z-40 lg:-twhidden lg:z-auto transition-opacity duration-200',
          {
            'bg-text-900 opacity-40': sidebarOpen,
            'opacity-0 pointer-events-none': !sidebarOpen,
          }
        )}
        style={{ top: `${bannerSpacing}px` }}
        aria-hidden="true"
      ></div>
      <div
        ref={sidebarRef}
        id="sidebar"
        className={`absolute z-40 left-0 lg:static lg:left-auto lg:top-auto lg:translate-x-0 transform h-full overflow-y-scroll lg:overflow-y-auto no-scrollbar w-64 flex-shrink-0 transition-transform duration-200 ease-in-out bg-primary-900
        ${sidebarOpen ? 'translate-x-0' : '-translate-x-64'}`}
        style={{ top: `${bannerSpacing}px` }}
      >
        <SidebarHeader sidebarOpen={sidebarOpen} toggleCallback={setSidebarOpen} />
        {/* Links */}
        <MenuListBox padding={16}>
          <ul className="mt-3">
            {links?.map(
              ({
                to,
                title,
                icon,
                requiresVerification,
                sideBarToggleCallback,
                isHidden,
                items,
                testId,
                highlight,
              }) => (
                <SideBarLink
                  key={to}
                  to={to}
                  title={title}
                  icon={icon}
                  requiresVerification={requiresVerification}
                  sideBarToggleCallback={sideBarToggleCallback}
                  isHidden={isHidden ?? false}
                  items={items}
                  testId={testId}
                  highlight={highlight}
                />
              )
            )}
          </ul>
        </MenuListBox>
      </div>
    </PanelBox>
  )
}

export default SideBar
